import { getUserAuthValues } from '@/src/utils/auth'
import { isUserSignedIn } from '@/src/utils/generalUtils/checkUserLogin'

/**
 * Push event to Google Analytics dataLayer
 * @param payload - The event payload data
 * @param event - The event name
 */
export const dataLayerGA = (payload: Record<string, any>, event: string): void => {
    try {
        if (typeof window === 'undefined' || !window.dataLayer || !Array.isArray(window.dataLayer)) {
            return
        }

        const { userId } = getUserAuthValues() || {}
        const finalPayload: Record<string, any> = {
            event: event,
            platform: 'website',
            user_status: isUserSignedIn() ? 'LoggedIn' : 'LoggedOut',
            ...payload
        }

        if (userId) {
            finalPayload.user_id = userId
        }

        window.dataLayer.push(finalPayload)
    } catch (error) {
        console.error('Error pushing to dataLayer:', error)
    }
}
